import Abstract from "../../abstract-view/abstract.js";

import {
  createElement
} from "../../render/render.js";

const createStickySectionTemplate = () => {
  return (
    `<section class="sticky-header sticky-header_top" style="display: none;">
      <div class="sticky-header-wrapper sticky-header-wrapper_cart">
        <div class="container">
          <ul class="header-cart-list">
            <li class="header-cart-list__item header-cart-list__item_sticky header-cart-list_logo">
              <a class="logo-link" href="/">
              <picture>
                <img
                  class="logo lazyload"
                  alt=""
                  width="140"
                  src="/assets/templates/main/images/logo.svg"
                  srcset="/assets/templates/main/images/lazy-load-placeholder.gif"
                  data-src="/assets/templates/main/images/logo.svg"
                  data-srcset="/assets/templates/main/images/logo.svg" data-aspectratio="140/34">
              </picture>
            </a>
            </li>
            <li class="header-cart-list__item header-cart-list__item_sticky header-cart-list__item_phone">
              <div class="header-cart-list-item-phone-wrapper">
                <a class="phone-link" href="tel:+78126043323">+7 (812) 604-33-23</a>
                <button class="phone-button phone-button_sticky">Перезвоните мне</button>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>`
  );
};

export default class CartTopStickySection extends Abstract {
  constructor() {
    super();

    this._phoneButton = null;
  }

  getElement() {
    if (!this._element) {
      this._element = createElement(this._getTemplate());
    }

    return this._element;
  }

  getPhoneButtonElement() {
    if (!this._phoneButton) {
      this._phoneButton = this.getElement().querySelector(`.phone-button`);
    }

    return this._phoneButton;
  }

  setSectionZIndex(value) {
    this.getElement().style.zIndex = value;
  }

  _getTemplate() {
    return createStickySectionTemplate();
  }
}
